
export const TEXT_LAYOUT_AUTO_WIDTH = 'auto-width' // 自动宽度
export const TEXT_LAYOUT_AUTO_HEIGHT = 'auto-height' // 自动高度
export const TEXT_LAYOUT_ZOOM = 'zoom' // 溢出缩排
export const TEXT_LAYOUT_FIXED_SIZE = 'fixed-size' // 固定宽高
